module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_32.2cb8459a.png";